import { configConstants as echs } from "../../../constants/configs";

const initialState = { loading: true, list: [], echeance: null };

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case echs.GET_ECHEANCES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case echs.GET_ECHEANCE:
      return {
        ...state,
        loading: false,
        echeance: payload,
      };
    default:
      return state;
  }
}
